import { getAssetPath } from "@commonUtils"

export const parsePageInfoWidgets = (data) => {
    let pageInfoWidgets = {}
    let pageInfoData = {}
    if (data?.go_to_cart_cta) {
        pageInfoWidgets["actionButton"] = {
            text: data.go_to_cart_cta?.text,
            action: data.go_to_cart_cta?.action,
            targetUrl: data.go_to_cart_cta?.details?.target_url,
        }
    }
    if (data?.go_to_cart_cta_timeout) {
        pageInfoWidgets["ctaTimeout"] = data?.go_to_cart_cta_timeout
    }
    if (data?.job_metadata) {
        pageInfoWidgets["jobMetadata"] = parserJobMetaData(
            data?.job_metadata,
            data.update_job,
            data.phone_confirmation_data,
            data.create_cart
        )
    }
    if (data?.dialog_data) {
        let cancelRequestData = data?.dialog_data
        pageInfoWidgets["cancelRequestData"] = {
            header: cancelRequestData?.header,
            subHeader: cancelRequestData?.description,
            icon: cancelRequestData?.icon,
            resolution: cancelRequestData?.resolution,
            primaryCta: {
                text: cancelRequestData?.confirm_cta?.text,
                functionMap: "cancelRequest",
            },
            secondaryCta: {
                text: cancelRequestData?.cancel_cta?.text,
                functionMap: "closeDialog",
            },
        }
        if (data?.cancel_cta) {
            pageInfoWidgets["cancelCta"] = {
                text: data?.cancel_cta?.text,
            }
        }
    }
    if (data?.order_id) {
        pageInfoData.orderId = data.order_id
    }
    return { widgets: pageInfoWidgets, data: pageInfoData }
}

export const parserJobMetaData = (
    widgetData,
    updateJob = null,
    phoneConfirmationData = null,
    createCart = null
) => {
    if (!widgetData) return {}
    return {
        imageUrl: widgetData.icon,
        header: widgetData.header,
        subHeader: widgetData.display_text,
        loaderInfo: {
            totalSteps: widgetData.loader_info?.total_count,
            currentStep: widgetData.loader_info?.progress,
            trackColor: widgetData.loader_info?.track_color,
            indicatorColor: widgetData.loader_info?.indicator_color,
            disabledColor: widgetData.loader_info?.disabled_color,
        },
        stateInfo: widgetData.job_info?.map((item) => ({
            iconUrl: item.icon,
            header: item.header,
            subHeader: item.display_text,
            timer: item.timer,
            stateText: item.info,
            timeoutText: item.timeout_info,
            timeoutHeader: item.timeout_header,
            stateMeta: item.credentials_details?.map((cred) => `${cred.detail_key} ${cred.detail_value}`),
            primaryCta: {
                label: item.close_cta?.text || item.retry_cta?.text,
                action: {
                    type: item.close_cta?.action || item.retry_cta?.action || "CLOSE",
                    redirectionUrl: item.close_cta?.target_url ? item.close_cta?.target_url : "/",
                    data: createCart,
                },
            },
            secondaryCta: {
                label: item.secondary_cta?.text,
                action: {
                    type: "VIEW_RX",
                    data: {
                        junkImages: !!Object.keys(item.junk_images ?? {}).length && {
                            header: item.junk_images?.header,
                            listOfImages: item.junk_images?.images?.map((item) => ({
                                imageUrl: item,
                            })),
                        },
                    },
                },
            },
            callInfo:
                Object.keys(item.call_info ?? {}).length > 0
                    ? {
                          header: item.call_info?.description,
                          ctaLabel: item.call_info?.cta?.text,
                          ctaAction: {
                              type: item.call_info?.cta?.action,
                              data: phoneConfirmationData && {
                                  header: phoneConfirmationData.header,
                                  subHeader: phoneConfirmationData.description,
                                  ctaLabel: phoneConfirmationData.cta?.text,
                                  inputLabel: phoneConfirmationData?.input_title,
                                  inputValue: parseInt(phoneConfirmationData?.phone_number),
                              },
                          },
                          phoneNumber: item.call_info?.phone_number,
                      }
                    : {},
            requestCall:
                Object.keys(item.request_call ?? {}).length > 0
                    ? {
                          header: item.request_call?.description,
                          ctaLabel: item.request_call?.cta?.text,
                          ctaIcon: getAssetPath("svgs/icons/resend_number.svg"),
                          ctaAction: {
                              type: item.request_call?.cta?.action,
                              data: updateJob,
                          },
                      }
                    : {},
        })),
    }
}
